import { render, staticRenderFns } from "./MyHomeworks.vue?vue&type=template&id=5692067b"
import script from "./MyHomeworks.vue?vue&type=script&lang=js"
export * from "./MyHomeworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports